import {
  createReducer,
  keyValueSetReducer,
  keyValueUpdateReducer,
} from '../../redux/helpers/redux-helpers'
import { FsCore } from '../../types/fs-core'
import { setFilterGroup, useFilterGroup, UseFilterGroupPayload } from './filters-actions'

export const filtersReducer = createReducer<FsCore.ESFiltersState>(
  {
    [setFilterGroup]: (state, { id, filterGroup }) => keyValueSetReducer(state, id, filterGroup),
    [useFilterGroup]: (state, { filterGroupId, usedById }: UseFilterGroupPayload) => {
      const filterGroup = state[filterGroupId]
      if (!filterGroup) return state
      const usedBy = [...filterGroup.usedBy]
      if (usedBy.indexOf(usedById) === -1) {
        usedBy.push(usedById)
      }
      return keyValueUpdateReducer(state, filterGroupId, {
        usedBy,
      })
    },
  },
  {},
)
